module.exports = __webpack_public_path__ + "img/box-skins-blue55.008b528a.jpg";